import { render, staticRenderFns } from "./GiftMessageModal.vue.html?vue&type=template&id=776f4dc1&scoped=true&"
import script from "./GiftMessageModal.component.js?vue&type=script&lang=vueJs&"
export * from "./GiftMessageModal.component.js?vue&type=script&lang=vueJs&"
import style0 from "./GiftMessageModal.scoped.scss?vue&type=style&index=0&id=776f4dc1&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f4dc1",
  null
  
)

export default component.exports